const cardButtonsStyle = () => ({
	buttonsWrapper: {
		width: '100%',
		display: 'flex',
		justifyContent: 'flex-end',
		marginTop: 16,
		'& .MuiButtonBase-root': {
			marginLeft: 8,
		},
	},
});

export default cardButtonsStyle;
